import newsReducer from './newsSlice';
import aboutReducer from './aboutSlice';
import statsReducer from './statsSlice';
import eventsReducer from './eventsSlice';
import sliderReducer from './sliderSlice';
import driverReducer from './driverSlice';
import galleryReducer from './gallerySlice';
import contactReducer from './contactSlice';
import historyReducer from './historySlice';
import communityReducer from './communitySlice';
import regulationReducer from './regulationSlice';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: {
        news: newsReducer,
        about: aboutReducer,
        stats: statsReducer,
        events: eventsReducer,
        slider: sliderReducer,
        driver: driverReducer,
        gallery: galleryReducer,
        contact: contactReducer,
        history: historyReducer,
        community: communityReducer,
        regulations: regulationReducer,
    },
});

export default store;
